/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
/*global window */
'use strict';

var createNavLinkComponent = require('./createNavLinkComponent');

module.exports = createNavLinkComponent();
